const createApiErrorResponse = (codeError: string) => ({
  response: { data: { errors: { code: codeError } } }
});

export default createApiErrorResponse;
